/* eslint-disable max-lines -- Expected in lookup files */

interface CssVariableLookup {
  category: string;
  variable: string;
}

export const CSS_VARIABLE_LOOKUP: Record<string, CssVariableLookup> = {
  // Core Colors
  "theme.light.theme-website-color-1": {
    variable: "theme-website-color-1",
    category: "appearance",
  },
  "theme.light.theme-website-color-2": {
    variable: "theme-website-color-2",
    category: "appearance",
  },
  "theme.light.theme-website-color-3": {
    variable: "theme-website-color-3",
    category: "appearance",
  },
  "theme.light.theme-website-color-4": {
    variable: "theme-website-color-4",
    category: "appearance",
  },
  "theme.light.theme-website-color-5": {
    variable: "theme-website-color-5",
    category: "appearance",
  },
  "theme.light.theme-website-color-6": {
    variable: "theme-website-color-6",
    category: "appearance",
  },

  "theme.dark.theme-website-color-1": {
    variable: "theme-website-color-1",
    category: "appearance",
  },
  "theme.dark.theme-website-color-2": {
    variable: "theme-website-color-2",
    category: "appearance",
  },
  "theme.dark.theme-website-color-3": {
    variable: "theme-website-color-3",
    category: "appearance",
  },
  "theme.dark.theme-website-color-4": {
    variable: "theme-website-color-4",
    category: "appearance",
  },
  "theme.dark.theme-website-color-5": {
    variable: "theme-website-color-5",
    category: "appearance",
  },
  "theme.dark.theme-website-color-6": {
    variable: "theme-website-color-6",
    category: "appearance",
  },

  // Style Colors
  "theme.light.theme-website-color-background-primary": {
    variable: "theme-website-color-background-primary",
    category: "appearance",
  },
  "theme.light.theme-website-color-background-secondary": {
    variable: "theme-website-color-background-secondary",
    category: "appearance",
  },
  "theme.light.theme-website-color-border": {
    variable: "theme-website-color-border",
    category: "appearance",
  },
  "theme.light.theme-website-color-text-primary": {
    variable: "theme-website-color-text-primary",
    category: "appearance",
  },
  "theme.light.theme-website-color-text-secondary": {
    variable: "theme-website-color-text-secondary",
    category: "appearance",
  },

  // Style Colors
  "theme.dark.theme-website-color-background-primary": {
    variable: "theme-website-color-background-primary",
    category: "appearance",
  },
  "theme.dark.theme-website-color-background-secondary": {
    variable: "theme-website-color-background-secondary",
    category: "appearance",
  },
  "theme.dark.theme-website-color-border": {
    variable: "theme-website-color-border",
    category: "appearance",
  },
  "theme.dark.theme-website-color-text-primary": {
    variable: "theme-website-color-text-primary",
    category: "appearance",
  },
  "theme.dark.theme-website-color-text-secondary": {
    variable: "theme-website-color-text-secondary",
    category: "appearance",
  },

  // Typography - H1
  "theme.h1.theme-website-h1-color-text": {
    variable: "theme-website-h1-color-text",
    category: "h1",
  },
  "theme.h1.theme-website-h1-font-family": {
    variable: "theme-website-h1-font-family",
    category: "h1",
  },
  "theme.h1.theme-website-h1-font-size": {
    variable: "theme-website-h1-font-size",
    category: "h1",
  },
  "theme.h1.theme-website-h1-font-weight": {
    variable: "theme-website-h1-font-weight",
    category: "h1",
  },
  "theme.h1.theme-website-h1-letter-spacing": {
    variable: "theme-website-h1-letter-spacing",
    category: "h1",
  },

  // Typography - H2
  "theme.h2.theme-website-h2-color-text": {
    variable: "theme-website-h2-color-text",
    category: "h2",
  },
  "theme.h2.theme-website-h2-font-family": {
    variable: "theme-website-h2-font-family",
    category: "h2",
  },
  "theme.h2.theme-website-h2-font-size": {
    variable: "theme-website-h2-font-size",
    category: "h2",
  },
  "theme.h2.theme-website-h2-font-weight": {
    variable: "theme-website-h2-font-weight",
    category: "h2",
  },
  "theme.h2.theme-website-h2-letter-spacing": {
    variable: "theme-website-h2-letter-spacing",
    category: "h2",
  },

  // Typography - H3
  "theme.h3.theme-website-h3-color-text": {
    variable: "theme-website-h3-color-text",
    category: "h3",
  },
  "theme.h3.theme-website-h3-font-family": {
    variable: "theme-website-h3-font-family",
    category: "h3",
  },
  "theme.h3.theme-website-h3-font-size": {
    variable: "theme-website-h3-font-size",
    category: "h3",
  },
  "theme.h3.theme-website-h3-font-weight": {
    variable: "theme-website-h3-font-weight",
    category: "h3",
  },
  "theme.h3.theme-website-h3-letter-spacing": {
    variable: "theme-website-h3-letter-spacing",
    category: "h3",
  },

  // Typography - H4
  "theme.h4.theme-website-h4-color-text": {
    variable: "theme-website-h4-color-text",
    category: "h4",
  },
  "theme.h4.theme-website-h4-font-family": {
    variable: "theme-website-h4-font-family",
    category: "h4",
  },
  "theme.h4.theme-website-h4-font-size": {
    variable: "theme-website-h4-font-size",
    category: "h4",
  },
  "theme.h4.theme-website-h4-font-weight": {
    variable: "theme-website-h4-font-weight",
    category: "h4",
  },
  "theme.h4.theme-website-h4-letter-spacing": {
    variable: "theme-website-h4-letter-spacing",
    category: "h4",
  },

  // Typography - H5
  "theme.h5.theme-website-h5-color-text": {
    variable: "theme-website-h5-color-text",
    category: "h5",
  },
  "theme.h5.theme-website-h5-font-family": {
    variable: "theme-website-h5-font-family",
    category: "h5",
  },
  "theme.h5.theme-website-h5-font-size": {
    variable: "theme-website-h5-font-size",
    category: "h5",
  },
  "theme.h5.theme-website-h5-font-weight": {
    variable: "theme-website-h5-font-weight",
    category: "h5",
  },
  "theme.h5.theme-website-h5-letter-spacing": {
    variable: "theme-website-h5-letter-spacing",
    category: "h5",
  },

  // Typography - H6
  "theme.h6.theme-website-h6-color-text": {
    variable: "theme-website-h6-color-text",
    category: "h6",
  },
  "theme.h6.theme-website-h6-font-family": {
    variable: "theme-website-h6-font-family",
    category: "h6",
  },
  "theme.h6.theme-website-h6-font-size": {
    variable: "theme-website-h6-font-size",
    category: "h6",
  },
  "theme.h6.theme-website-h6-font-weight": {
    variable: "theme-website-h6-font-weight",
    category: "h6",
  },
  "theme.h6.theme-website-h6-letter-spacing": {
    variable: "theme-website-h6-letter-spacing",
    category: "h6",
  },

  // Typography - P1
  "theme.p1.theme-website-p1-color-text": {
    variable: "theme-website-p1-color-text",
    category: "p1",
  },
  "theme.p1.theme-website-p1-font-family": {
    variable: "theme-website-p1-font-family",
    category: "p1",
  },
  "theme.p1.theme-website-p1-font-size": {
    variable: "theme-website-p1-font-size",
    category: "p1",
  },
  "theme.p1.theme-website-p1-font-weight": {
    variable: "theme-website-p1-font-weight",
    category: "p1",
  },
  "theme.p1.theme-website-p1-letter-spacing": {
    variable: "theme-website-p1-letter-spacing",
    category: "p1",
  },

  // Typography - P2
  "theme.p2.theme-website-p2-color-text": {
    variable: "theme-website-p2-color-text",
    category: "p2",
  },
  "theme.p2.theme-website-p2-font-family": {
    variable: "theme-website-p2-font-family",
    category: "p2",
  },
  "theme.p2.theme-website-p2-font-size": {
    variable: "theme-website-p2-font-size",
    category: "p2",
  },
  "theme.p2.theme-website-p2-font-weight": {
    variable: "theme-website-p2-font-weight",
    category: "p2",
  },
  "theme.p2.theme-website-p2-letter-spacing": {
    variable: "theme-website-p2-letter-spacing",
    category: "p2",
  },

  // Typography - P3
  "theme.p3.theme-website-p3-color-text": {
    variable: "theme-website-p3-color-text",
    category: "p3",
  },
  "theme.p3.theme-website-p3-font-family": {
    variable: "theme-website-p3-font-family",
    category: "p3",
  },
  "theme.p3.theme-website-p3-font-size": {
    variable: "theme-website-p3-font-size",
    category: "p3",
  },
  "theme.p3.theme-website-p3-font-weight": {
    variable: "theme-website-p3-font-weight",
    category: "p3",
  },
  "theme.p3.theme-website-p3-letter-spacing": {
    variable: "theme-website-p3-letter-spacing",
    category: "p3",
  },

  // Primary Button
  "theme.primary_button.theme-website-primary-button-default-background-color":
    {
      variable: "theme-website-primary-button-default-background-color",
      category: "primary_button",
    },
  "theme.primary_button.theme-website-primary-button-hover-background-color": {
    variable: "theme-website-primary-button-hover-background-color",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-default-font-family": {
    variable: "theme-website-primary-button-default-font-family",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-default-text-color": {
    variable: "theme-website-primary-button-default-text-color",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-hover-text-color": {
    variable: "theme-website-primary-button-hover-text-color",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-default-font-weight": {
    variable: "theme-website-primary-button-default-font-weight",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-default-font-size": {
    variable: "theme-website-primary-button-default-font-size",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-default-letter-spacing": {
    variable: "theme-website-primary-button-default-letter-spacing",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-default-border-color": {
    variable: "theme-website-primary-button-default-border-color",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-hover-border-color": {
    variable: "theme-website-primary-button-hover-border-color",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-default-border-width": {
    variable: "theme-website-primary-button-default-border-width",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-hover-border-width": {
    variable: "theme-website-primary-button-hover-border-width",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-padding-top": {
    variable: "theme-website-primary-button-padding-top",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-padding-bottom": {
    variable: "theme-website-primary-button-padding-bottom",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-padding-left": {
    variable: "theme-website-primary-button-padding-left",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-padding-right": {
    variable: "theme-website-primary-button-padding-right",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-default-shadow": {
    variable: "theme-website-primary-button-default-shadow",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-hover-shadow": {
    variable: "theme-website-primary-button-hover-shadow",
    category: "primary_button",
  },
  "theme.primary_button.theme-website-primary-button-default-border-left-top-radius":
    {
      variable: "theme-website-primary-button-default-border-left-top-radius",
      category: "primary_button",
    },
  "theme.primary_button.theme-website-primary-button-default-border-left-bottom-radius":
    {
      variable:
        "theme-website-primary-button-default-border-left-bottom-radius",
      category: "primary_button",
    },
  "theme.primary_button.theme-website-primary-button-default-border-right-top-radius":
    {
      variable: "theme-website-primary-button-default-border-right-top-radius",
      category: "primary_button",
    },
  "theme.primary_button.theme-website-primary-button-default-border-right-bottom-radius":
    {
      variable:
        "theme-website-primary-button-default-border-right-bottom-radius",
      category: "primary_button",
    },
  "theme.primary_button.theme-website-primary-button-hover-border-left-top-radius":
    {
      variable: "theme-website-primary-button-hover-border-left-top-radius",
      category: "primary_button",
    },
  "theme.primary_button.theme-website-primary-button-hover-border-right-top-radius":
    {
      variable: "theme-website-primary-button-hover-border-right-top-radius",
      category: "primary_button",
    },
  "theme.primary_button.theme-website-primary-button-hover-border-right-bottom-radius":
    {
      variable: "theme-website-primary-button-hover-border-right-bottom-radius",
      category: "primary_button",
    },
  "theme.primary_button.theme-website-primary-button-hover-border-left-bottom-radius":
    {
      variable: "theme-website-primary-button-hover-border-left-bottom-radius",
      category: "primary_button",
    },

  // Secondary Button
  "theme.secondary_button.theme-website-secondary-button-default-background-color":
    {
      variable: "theme-website-secondary-button-default-background-color",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-hover-background-color":
    {
      variable: "theme-website-secondary-button-hover-background-color",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-default-font-family": {
    variable: "theme-website-secondary-button-default-font-family",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-default-text-color": {
    variable: "theme-website-secondary-button-default-text-color",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-hover-text-color": {
    variable: "theme-website-secondary-button-hover-text-color",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-default-font-weight": {
    variable: "theme-website-secondary-button-default-font-weight",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-default-font-size": {
    variable: "theme-website-secondary-button-default-font-size",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-default-letter-spacing":
    {
      variable: "theme-website-secondary-button-default-letter-spacing",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-default-border-color":
    {
      variable: "theme-website-secondary-button-default-border-color",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-hover-border-color": {
    variable: "theme-website-secondary-button-hover-border-color",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-default-border-width":
    {
      variable: "theme-website-secondary-button-default-border-width",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-hover-border-width": {
    variable: "theme-website-secondary-button-hover-border-width",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-padding-top": {
    variable: "theme-website-secondary-button-padding-top",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-padding-bottom": {
    variable: "theme-website-secondary-button-padding-bottom",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-padding-left": {
    variable: "theme-website-secondary-button-padding-left",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-padding-right": {
    variable: "theme-website-secondary-button-padding-right",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-default-shadow": {
    variable: "theme-website-secondary-button-default-shadow",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-hover-shadow": {
    variable: "theme-website-secondary-button-hover-shadow",
    category: "secondary_button",
  },
  "theme.secondary_button.theme-website-secondary-button-default-border-left-top-radius":
    {
      variable: "theme-website-secondary-button-default-border-left-top-radius",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-default-border-left-bottom-radius":
    {
      variable:
        "theme-website-secondary-button-default-border-left-bottom-radius",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-default-border-right-top-radius":
    {
      variable:
        "theme-website-secondary-button-default-border-right-top-radius",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-default-border-right-bottom-radius":
    {
      variable:
        "theme-website-secondary-button-default-border-right-bottom-radius",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-hover-border-left-top-radius":
    {
      variable: "theme-website-secondary-button-hover-border-left-top-radius",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-hover-border-left-bottom-radius":
    {
      variable:
        "theme-website-secondary-button-hover-border-left-bottom-radius",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-hover-border-right-top-radius":
    {
      variable: "theme-website-secondary-button-hover-border-right-top-radius",
      category: "secondary_button",
    },
  "theme.secondary_button.theme-website-secondary-button-hover-border-right-bottom-radius":
    {
      variable:
        "theme-website-secondary-button-hover-border-right-bottom-radius",
      category: "secondary_button",
    },
};
